// components/shared/ConfirmDialog.js
// דיאלוג אישור מודולרי
// שימוש:
//   <ConfirmDialog
//     open={open}
//     title="מחיקת יחידה"
//     message="האם למחוק את היחידה?"
//     onConfirm={handleDelete}
//     onCancel={() => setOpen(false)}
//     destructive
//   />

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = null,
  cancelLabel = null,
  destructive = false,
  loading = false,
  children = null,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      data-testid="shared__confirm-dialog"
      aria-labelledby="confirm-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="confirm-dialog-title" data-testid="shared__confirm-dialog__title">
        {title}
      </DialogTitle>

      <DialogContent>
        {message && (
          <DialogContentText data-testid="shared__confirm-dialog__message">
            {message}
          </DialogContentText>
        )}
        {children}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          data-testid="shared__confirm-dialog__button--cancel"
          onClick={onCancel}
          disabled={loading}
          color="inherit"
        >
          {cancelLabel || t('common.cancel')}
        </Button>
        <Button
          data-testid="shared__confirm-dialog__button--confirm"
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {loading
            ? t('common.saving')
            : confirmLabel || (destructive ? t('common.delete') : t('common.confirm'))
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}
